/* ===========================================================================
   PHP TUNE ADD-ON  —  tune-addon.js
   Offers the Staging Limiter / Lope Idle tune ($50) as an add-on on any
   product page, capturing the same info the standalone product captures
   so the customer never has to leave.

   INSTALL
     1. Online Store > Themes > ... > Edit code > Assets > Add a new asset
        > Upload this file (tune-addon.js)
     2. In the theme customizer, on the product template, add a
        "Custom Liquid" block below the Buy buttons containing:

          <div id="ph-tune-addon" data-free="true"></div>
          <script src="{{ 'tune-addon.js' | asset_url }}" defer></script>

        data-free="true"   -> Medusa   (label reads FREE with your Medusa)
        data-free="false"  -> Hydra Chip (label reads +$50)

   PRICING
     This never fakes a price. It always adds the real $50 variant.
     To make it free with a Medusa create an automatic discount:
       Discounts > Automatic > Buy X Get Y
       Buys 1x Medusa Interface  ->  gets 1x Staging Limiter free
     Schedule it to the Labor Day window and it switches itself off.

   LINE ITEM PROPERTIES WRITTEN (identical names to the standalone product,
   so fulfilment sees the same fields):
       Hydra SN  |  RPM  |  Uploaded File  |  Uploaded File Name
   =========================================================================== */
(function () {
  'use strict';

  var MOUNT = document.getElementById('ph-tune-addon');
  if (!MOUNT || MOUNT.dataset.phInit) { return; }
  MOUNT.dataset.phInit = '1';

  var FREE = MOUNT.getAttribute('data-free') === 'true';
  var LIMITER_HANDLE = 'staging-limiter-for-hydra-chip';

  var VARIANTS = [
    { id: '52364229214340', label: 'Hard Limiter (Aggressive Fuel Cut)' },
    { id: '52364229247108', label: 'Soft Limiter (Soft Fuel Cut. RPM may creep depending on load)' },
    { id: '52760726700164', label: 'Lope Idle' }
  ];

  var priceLabel = FREE
    ? '<s>$50</s> FREE with your Medusa'
    : '+$50';

  /* ---------------------------------------------------------------- styles */
  var css = ''
    + '.ph-addon{border:1px solid #d9d9d9;border-radius:8px;padding:16px;margin:20px 0;background:#fafafa}'
    + '.ph-addon__toggle{display:flex;align-items:flex-start;gap:10px;cursor:pointer;font-weight:600;line-height:1.4}'
    + '.ph-addon__toggle input{margin-top:3px;width:18px;height:18px;flex:none;cursor:pointer}'
    + '.ph-addon__price{color:#b3261e;font-weight:700;white-space:nowrap}'
    + '.ph-addon__blurb{margin:6px 0 0 28px;font-size:14px;color:#555;font-weight:400;line-height:1.5}'
    + '.ph-addon__fields{display:none;margin-top:16px;padding-top:16px;border-top:1px solid #e2e2e2}'
    + '.ph-addon__fields.is-open{display:block}'
    + '.ph-addon__row{margin-bottom:14px}'
    + '.ph-addon__row label{display:block;margin-bottom:6px;font-weight:600;font-size:14px}'
    + '.ph-addon__row input,.ph-addon__row select{width:100%;padding:10px;border:1px solid #ccc;'
    + 'border-radius:4px;font-size:14px;background:#fff;box-sizing:border-box}'
    + '.ph-addon__req{color:#b3261e}'
    + '.ph-addon__err{color:#b3261e;font-size:12px;display:none;margin-top:4px}'
    + '.ph-addon__err.is-shown{display:block}'
    + '.ph-addon__warn{font-size:13px;line-height:1.5;background:#fff4f4;border-left:3px solid #b3261e;'
    + 'padding:10px 12px;margin-top:14px;border-radius:0 4px 4px 0}'
    + '.ph-addon__busy{display:none;margin-top:10px;font-size:14px;font-weight:600}'
    + '.ph-addon__busy.is-shown{display:block}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------------------------------------------------------------- markup */
  var opts = VARIANTS.map(function (v) {
    return '<option value="' + v.id + '">' + v.label + '</option>';
  }).join('');

  MOUNT.innerHTML = ''
    + '<div class="ph-addon">'
    +   '<label class="ph-addon__toggle" for="ph-addon-enable">'
    +     '<input type="checkbox" id="ph-addon-enable">'
    +     '<span>Add a Staging Limiter or Lope Idle tune '
    +       '<span class="ph-addon__price">' + priceLabel + '</span></span>'
    +   '</label>'
    +   '<p class="ph-addon__blurb">We write it into your existing Hydra tune file and email the '
    +     'updated file back. Fill this in here and you won\'t need a second order.</p>'
    +   '<div class="ph-addon__fields" id="ph-addon-fields">'
    +     '<div class="ph-addon__row">'
    +       '<label for="ph-addon-variant">Tune type <span class="ph-addon__req">*</span></label>'
    +       '<select id="ph-addon-variant">' + opts + '</select>'
    +     '</div>'
    +     '<div class="ph-addon__row">'
    +       '<label for="ph-addon-sn">Hydra Serial Number <span class="ph-addon__req">*</span></label>'
    +       '<input type="text" id="ph-addon-sn" maxlength="8" autocomplete="off" '
    +         'placeholder="Enter Hydra Serial Number (no spaces)">'
    +       '<span class="ph-addon__err" id="ph-addon-sn-err">Serial number must be 8 characters, no spaces.</span>'
    +     '</div>'
    +     '<div class="ph-addon__row">'
    +       '<label for="ph-addon-rpm">RPM <span class="ph-addon__req">*</span></label>'
    +       '<input type="number" id="ph-addon-rpm" min="1" step="1" placeholder="Enter RPM">'
    +       '<span class="ph-addon__err" id="ph-addon-rpm-err">Enter the RPM you want.</span>'
    +     '</div>'
    +     '<div class="ph-addon__row">'
    +       '<label for="ph-addon-file">Upload your tune file <span class="ph-addon__req">*</span></label>'
    +       '<input type="file" id="ph-addon-file" accept=".hcf,.bin">'
    +       '<span class="ph-addon__err" id="ph-addon-file-err">Please attach your .hcf or .bin tune file.</span>'
    +     '</div>'
    +     '<div class="ph-addon__warn"><strong>BE ADVISED:</strong> We recommend choosing an RPM limiter '
    +       '<strong>BELOW</strong> the stall rating of your torque converter. Choosing too high of an RPM '
    +       'limiter will still push through the brakes during staging. '
    +       '<strong>Revisions are not offered due to choosing the wrong RPM.</strong></div>'
    +     '<div class="ph-addon__busy" id="ph-addon-busy">Adding to cart&hellip;</div>'
    +   '</div>'
    + '</div>';

  /* ------------------------------------------------------------- behaviour */
  var box     = document.getElementById('ph-addon-enable');
  var fields  = document.getElementById('ph-addon-fields');
  var variant = document.getElementById('ph-addon-variant');
  var sn      = document.getElementById('ph-addon-sn');
  var rpm     = document.getElementById('ph-addon-rpm');
  var file    = document.getElementById('ph-addon-file');
  var busy    = document.getElementById('ph-addon-busy');

  function err(id, on) {
    var e = document.getElementById(id);
    if (e) { e.classList.toggle('is-shown', !!on); }
  }

  box.addEventListener('change', function () {
    fields.classList.toggle('is-open', box.checked);
  });

  // strip spaces as they type — same behaviour as the standalone product page
  sn.addEventListener('input', function () {
    this.value = this.value.replace(/\s/g, '');
    err('ph-addon-sn-err', false);
  });
  rpm.addEventListener('input',  function () { err('ph-addon-rpm-err', false); });
  file.addEventListener('change', function () { err('ph-addon-file-err', false); });

  function valid() {
    var ok = true;
    if (!/^[A-Za-z0-9]{8}$/.test(sn.value))    { err('ph-addon-sn-err', true);   ok = false; }
    if (!rpm.value || Number(rpm.value) <= 0)  { err('ph-addon-rpm-err', true);  ok = false; }
    if (!file.files || !file.files[0])         { err('ph-addon-file-err', true); ok = false; }
    return ok;
  }

  // Adds the add-on first (as FormData, so the uploaded file survives),
  // then the main product, then sends them to the cart.
  function addBoth(form) {
    busy.classList.add('is-shown');

    var addon = new FormData();
    addon.append('id', variant.value);
    addon.append('quantity', '1');
    addon.append('properties[Hydra SN]', sn.value);
    addon.append('properties[RPM]', rpm.value);
    addon.append('properties[Uploaded File]', file.files[0]);
    addon.append('properties[Uploaded File Name]', file.files[0].name);

    fetch('/cart/add.js', { method: 'POST', body: addon })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error(j.description || 'The tune add-on could not be added.');
          });
        }
        return fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error(j.description || 'The product could not be added.');
          });
        }
        window.location.href = '/cart';
      })
      .catch(function (e) {
        busy.classList.remove('is-shown');
        window.alert(e.message + '\n\nYou can also order the tune on its own at '
          + '/products/' + LIMITER_HANDLE);
      });
  }

  // Intercept the add-to-cart click in the capture phase so we run before the
  // theme's own submit handler — but only when the add-on is actually ticked.
  document.addEventListener('click', function (ev) {
    if (!box.checked) { return; }

    var btn = ev.target.closest && ev.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) { return; }

    var form = btn.form || btn.closest('form');
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) { return; }

    ev.preventDefault();
    ev.stopImmediatePropagation();

    if (!valid()) {
      fields.classList.add('is-open');
      var first = document.querySelector('.ph-addon__err.is-shown');
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    addBoth(form);
  }, true);
})();
